import type { RouteLocationRaw } from '#vue-router';

export class RedirectError extends Error {
	constructor(public target: RouteLocationRaw) {
		super('Logical Redirect');
		this.name = 'RedirectError';
	}
}

export const isRedirectError = (error: unknown): error is RedirectError => error instanceof RedirectError;

export class MerchantNotFoundError extends Error {
	constructor() {
		super('Merchant not found');
		this.name = 'MerchantNotFoundError';
	}
}

export const isMerchantNotFoundError = (error: unknown): error is MerchantNotFoundError => error instanceof MerchantNotFoundError;

export type MerchantForbiddenReason = 'unregistered' | 'rejected';

export class MerchantForbiddenError extends Error {
	constructor(public reason: MerchantForbiddenReason) {
		super(`Forbidden: ${reason}`);
		this.name = 'MerchantForbiddenError';
	}
}

export const isMerchantForbiddenError = (error: unknown): error is MerchantForbiddenError => error instanceof MerchantForbiddenError;

export type MerchantError = MerchantForbiddenError | MerchantNotFoundError;

export type SaveChannelErrorType = 'create' | 'update' | 'delete' | 'validation';

export type SaveChannelError = {
	id: string;
	type: SaveChannelErrorType;
};

export class SaveChannelsError extends Error {
	constructor(public channels: SaveChannelError[], cause?: unknown) {
		super(`Unable to save channels`);
		this.name = 'SaveChannelsError';
		this.cause = cause;
	}
}
